// components/notifications/meeting/MeetingRequestNotificationCard.jsx
import React, { useMemo, useState, useCallback } from 'react';
import {
  Box, Typography, Avatar, Stack,
} from '@mui/material';
// import VideocamIcon from '@mui/icons-material/Videocam';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import ActionsRow from '../invitation/ActionsRow';
import { ReferenceChips } from '../helpers/notificationUtils';
import { axiosService } from 'shared/helpers/axios';
import PollDialog from './PollDialog';
import { formatDistanceToNow } from 'date-fns';
import {  Circle as CircleIcon } from '@mui/icons-material';


const MeetingRequestNotificationCard = ({ notification, onMarkAsRead }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const payload = notification.payload || {};
  
  // console.log("PPPP", payload);

  const meetingRequestId = payload.meeting_request_id;
  const title = notification.ntype === 'meeting_request' ? payload.title || payload.meeting_title : payload.poll_title;
  const description = payload.description || '';
  const fromUserName = payload.from_user_name || payload.sender_name || 'Someone';
  const fromUserAvatarUrl = payload.from_user_avatar || payload.sender_avatar || null;
  
  // console.log("notification:", notification);

  const [imgBroken, setImgBroken] = useState(false);
  const showInitials = !fromUserAvatarUrl || imgBroken;
  const fromUserInitials = fromUserName.split(' ').map(n => n[0]).join('').toUpperCase();
  
  
  // Poll dialog state
  const [showPollDialog, setShowPollDialog] = useState(false);

  // Open poll dialog
  const handleOpenPoll = () => {
    setShowPollDialog(true);
  };
  

  const handleDeclineMeeting = useCallback(async () => {
    try {
      await axiosService.post(`/meetings/${meetingRequestId}/decline/`);
      onMarkAsRead(notification.id);
    } catch (error) {
      console.error("Error declining meeting:", error);
    }
  }, [meetingRequestId, notification.id, onMarkAsRead]);

  const actions = useMemo(() => {
    const list = [
      {
        key: 'view-poll',
        label: '📊 View Poll',
        color: 'primary',
        onClick: handleOpenPoll,
      },
      {
         key: 'decline-meeting',
         label: 'Decline',
         color: 'error',
         variant: 'outlined',
         onClick: handleDeclineMeeting,
      },
    ];
    
    return list;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleOpenPoll]);
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        py: 1,
        px: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        backgroundColor: notification.is_read ? 'transparent' : 'action.hover',
        transition: 'background-color 0.2s',
        '&:hover': {
          backgroundColor: 'action.selected',
        },
      }}
    >
      {/* Avatar */}
      <Avatar
        src={showInitials ? undefined : fromUserAvatarUrl}
        alt={fromUserName || 'Meeting organizer'}
        imgProps={{ onError: () => setImgBroken(true) }}
        sx={{
          width: 32,
          height: 32,
          flexShrink: 0,
          mt: 0.25,
          backgroundColor: theme.palette.primary.avatar,
          color: 'white',
        }}
      >
        {showInitials ? fromUserInitials : null}
      </Avatar>

      {/* Content column */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {/* Row 1: message + timestamp + unread dot */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
          <Typography
            variant="body2"
            sx={{ flex: 1, minWidth: 0 }}
          >
            <Box component="span" color="text.primary" fontWeight={600}>
              {fromUserName}
            </Box>
            {' '}
            <Box component="span" color="text.secondary">
              sent you a meeting request:
            </Box>
            {' '}
            <Box component="span" color="text.primary" fontWeight={500}>
              {title}
            </Box>
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0, mt: 0.25 }}>
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              {formatDistanceToNow(new Date(notification.created), { addSuffix: true })}
            </Typography>
            {!notification.is_read && (
              <CircleIcon sx={{ fontSize: 8, color: 'primary.main' }} />
            )}
          </Box>
        </Box>

        {/* Row 2: reference chips */}
        <Stack direction="row" spacing={1} sx={{ mt: 0.75, flexWrap: 'wrap' }}>
          <ReferenceChips notification={notification} onOpen={(href) => href && navigate(href)} />
        </Stack>

        {/* Row 3: action buttons */}
        <Box sx={{ mt: 0.75 }}>
          <ActionsRow
            actions={actions}
            onAction={(a) => a.onClick?.()}
            onOpenHref={(href) => console.log('open', href)}
          />
        </Box>
      </Box>

      {/* Poll Dialog */}
      <PollDialog
        open={showPollDialog}
        onClose={() => setShowPollDialog(false)}
        meetingRequestId={notification.payload.meeting_request_id}
        pollId={notification.payload.poll_id}
        onVoteSubmit={() => {
          setShowPollDialog(false);
          if (onMarkAsRead) {
            onMarkAsRead(notification.id);
          }
        }}
      />
    </Box>
      
    
    
  );
}

export default MeetingRequestNotificationCard;
